import { StateType } from "models"
import { WageSide } from "models/paymentLink";

export type PaymentReportItem = {
    paymentFactId: number,
    paymentId: number,
    gatewayName: string,
    merchantName: string,
    terminalName: string,
    applicationName: string,
    state: StateType,
    stateDescription: string,
    payerAmount: number,
    amount: number,
    totalWageAmount: number,
    insertDate: string,
    insertTime: string,
    trackingNumber: number,
    gatewayTransactionId: number,
    payerCardMask: string,
    payerMobileNumber: string,
    wageSide: WageSide,
    wageSideDescription: string
}
export type PaymentAggrigationReportItem = {
    paymentAggregationId: number,
    gatewayName: string,
    merchantName: string,
    terminalName: string,
    applicationName: string,
    state: StateType,
    stateDescription: string,
    amount: number,
    totalWageAmount: number,
    insertDateMi: string;
    insertDate: string,
    insertTime: string,
    wageSide: WageSide,
    wageSideDescription: string
}
export type Payment = {
    application: {
        name: string,
        nameEn: string
    },
    payment: {
        amount: number,
        clientId: string,
        description:string,
        extraData: string,
        gatewayTransactionId: string,
        insertDateMi: string;
        insertDate: string,
        insertTime: string,
        ip: string | null,
        packageName: string,
        packageVersion: string,
        payerAmount: number,
        payerCardMask: string,
        payerEmail: string | null,
        payerMobileNumber: string,
        payerName: string | null,
        payerNationalCode: string | null,
        productName: string,
        referenceId: string,
        sdkVersion: string,
        state: StateType,
        stateDescription: string,
        totalWageAmount: number,
        trackingNumber: number,
        uniqueCode: string,
        urlReferrer: string,
        wageSide: WageSide,
        wageSideDescription: string
    },
    terminal: {
        name: string
    }
}
export enum PaymentStateType  {
    //[Description("درخواست پرداخت")]
    paymentRequest = 0,

    //[Description("ورود به درگاه")]
    enterGateway = 5,

    //[Description("پرداخت موفق")]
    successfulPayment = 10,

    //[Description("پرداخت موفق")]
    waitForVerify = 11,

    //[Description("پرداخت ناموفق")]
    paymentFailed = 15,

    //[Description("پرداخت تایید شده")]
    paymentConfirmed = 20,
}